import React from "react";
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {
    render() {
        const BankSummarySearchData = this.props.BankSummarySearchData;
        const BankSummaryData = this.props.BankSummaryData;
        const selectedDatePDF = this.props.selectedDatePDF;
        const months = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE","JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];

        return (
            <div>
                <h3><center><u>Bank Summary Report</u></center></h3>
                <div>&nbsp;</div>
                <h3 ><center>BOUGHT LEAF BALANCE PAYMENT FOR THE MONTH OF {months[selectedDatePDF.getMonth()]} - {selectedDatePDF.getFullYear()}</center></h3>
                <div>&nbsp;</div>
                <h3><center>Group: {BankSummarySearchData.groupName}</center></h3>
                <h3><center>Factory:{BankSummarySearchData.factoryName}</center></h3>
                <h3><center>Route:{(BankSummarySearchData.routeName === undefined) ? "All Routes" : BankSummarySearchData.routeName}</center></h3>
                <h3><center>Bank: {(BankSummarySearchData.bank === undefined) ? "All Banks" : BankSummarySearchData.bank}</center></h3>
                <h3><center>Branch:{(BankSummarySearchData.branch === undefined) ? "All Branches" : BankSummarySearchData.branch}</center></h3>
                <div>&nbsp;</div>
                <div>
                    <Box minWidth={1050}>
                        {BankSummaryData.length > 0 ?
                            <TableContainer>
                                <Table aria-label="caption table" size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Bank</TableCell>
                                            <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Branch</TableCell>
                                            <TableCell align={'right'} style={{ border: "1px solid #ccc" }}>Amount(Rs.)</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {BankSummaryData.map((data, index) => (
                                            <TableRow key={index}>
                                                <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                    {data.bankName}
                                                </TableCell>
                                                <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                    {data.branchName}
                                                </TableCell>
                                                <TableCell align={'right'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                                    {data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                    <TableRow style={{ border: "1px solid #ccc" }}>
                                        <TableCell align={'left'} style={{ borderBottom: "none" }}><b>Total</b></TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}></TableCell>
                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none", borderLeft: "1px solid #ccc" }}>
                                            <b>
                                                {BankSummaryData.reduce((sum, row) => sum + row.amount, 0).toLocaleString('en-US', {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })}
                                            </b>
                                        </TableCell>
                                    </TableRow>
                                </Table>
                            </TableContainer>
                            : null}
                    </Box>
                </div>
                <div>&nbsp;</div>
                <h3><center>***** End of List *****</center></h3>
            </div>
        );
    }
}